import { useParams } from 'react-router-dom';
import { useEffect, useState, useCallback } from 'react';
import IProduct  from '../../entities/IProduct';
import {IMedia} from '../../entities/IMedia';
import ProductService from "../../services/ProductService";
import {get} from '../../services/HttpApi';
import { unwrapData } from '../../services/apiUtils';

export const useProductData = (
    id: number,
    handleDefaultValues: (productData: IProduct) => void
  ) => {

    const [product, setProduct] = useState<IProduct>();

    const [isLoading, setIsLoading] = useState(true);

    const fetchProduct = useCallback((id:number) => {

      return get(`products/${id}`);

    }, [setProduct]);

    useEffect(() => {
      if (!id || id <= 0) {
        setIsLoading(false);
        return;
      }
      setIsLoading(true);
      fetchProduct(id)
        .then((res: any) => {
          setIsLoading(false);
          const productData = unwrapData(res) as IProduct;
          setProduct(productData);
          handleDefaultValues(productData);
        })
        .catch(() => {
          setIsLoading(false);
        })
    }, [fetchProduct, id, setIsLoading, handleDefaultValues])

    return {
      product,
      fetchProduct,
      isLoading
    }
  }